import React from "react";
import { useTranslation } from "react-i18next";
import { ImSpinner9 } from "react-icons/im";

const Button = ({
  className,
  labelclass,
  value,
  children,
  onClick,
  disabled,
  variant = "btn-primary",
  size = "btn-md",
  isLoading,
  iconStart,
  iconEnd,
  round,
  type = "button",
  icon,
  isIcon,
  ...rest
}) => {
  const { t } = useTranslation()
  const validVariants = ["btn-primary", "btn-primary-light", "btn-outline", "btn-secondary", "btn-danger", "btn-success", "btn-warning", "btn-black", "btn-gray", "btn-primary-outline", "btn-secondary-outline", "btn-danger-outline", "btn-success-outline", "btn-warning-outline", "btn-black-outline", "btn-gray-outline", "btn-white"];
  const validSizes = ["btn-md", "btn-sm", "btn-lg"];
  const finalVariant = validVariants.includes(variant) ? variant : "btn-primary";
  const finalSize = validSizes.includes(size) ? size : "btn-md";
  
  return (
    <button
      className={`btn group whitespace-nowrap ${isLoading ? "btn-loading" : ''} ${finalVariant} ${finalSize} ${className} ${labelclass} ${round ? "rounded-lg" : "rounded-full"} ${isIcon && (size === 'btn-md' ? '!size-12 !px-0' : size === 'btn-sm' ? '!size-10 !px-0' : size === 'btn-lg' ? '!size-14 !px-0' : '')} !flex-shrink-0`}
      disabled={disabled ? true : false}
      onClick={onClick}
      type={type}
      {...rest}
    >
      {isLoading ? (
        <span className="w-full flex items-center justify-center gap-3">
          <ImSpinner9 className="animate-spin text-xl" />{" "}
          <span>{t("Loading")}</span>
        </span>
      ) : (
        <>
          {iconStart} {icon} {children} {value} {iconEnd}
        </>
      )}
    </button>
  );
};

export default Button;
